var GRID_SHOW_INSERT = true;
var GRID_SHOW_DELETE = true;

execv2.form.multipletable.util = {};

execv2.form.multipletable.util.checkIfHasAnyInput = function (tbl) {
    return tbl.querySelectorAll("input:not([type='hidden']),textarea,select").length > 0;
};

execv2.form.multipletable.util.checkIfHasAnyLabel = function (tbl) {
    return tbl.querySelectorAll("div[xtype]").length > 0;
};

execv2.form.multipletable.util.checkIfHasAnyInterfaceElement = function (tbl) {
    return tbl.querySelectorAll("[data-fieldformat='LINK']:not([type='hidden'])").length > 0 ||
        tbl.querySelectorAll("[data-fieldformat='TITLE']:not([type='hidden'])").length > 0 ||
        tbl.querySelectorAll("[data-fieldformat='SUBTITLE']:not([type='hidden'])").length > 0 ||
        tbl.querySelectorAll("[data-fieldformat='SUBTITLE_2']:not([type='hidden'])").length > 0 ||
        tbl.querySelectorAll("[data-fieldformat='TEXTEDITOR']:not([type='hidden'])").length > 0;
}

execv2.form.multipletable.setup = function () {
    const tbls = document.querySelectorAll("table[mult='S']");

    h.forEach(tbls, function (i, tbl) {
        execv2.form.multipletable.hideIfEmpty(tbl);
        execv2.form.multipletable.addButtons(tbl);
    });
}

execv2.form.multipletable.hideIfEmpty = function (tbl) {
    if (!execv2.form.multipletable.util.checkIfHasAnyInput(tbl)
        && !execv2.form.multipletable.util.checkIfHasAnyLabel(tbl)
        && !execv2.form.multipletable.util.checkIfHasAnyInterfaceElement(tbl)) {
        bsml.hide(tbl);
    }
}

execv2.form.multipletable.addButtons = function (tbl) {
    if (execv2.form.multipletable.util.checkIfHasAnyInput(tbl)) {
        execv2.util.removeWhiteSpaces(tbl);

        h.forEach(tbl.rows, function (i, row) {
            var html = "";
            const newcell = row.insertCell(0);
            newcell.style.width = "30px";

            if (i === 0 && GRID_SHOW_INSERT) {
                html = `<button type="button" onclick="execv2.form.multipletable.addRow(this, true, true)" id="btnInsertNewRow" class="btn btn-secondary btn-xs btn-insert-mv">${mlBtnInsert}</button>`;
                newcell.insertAdjacentHTML("afterbegin", html);
            } else if (i > 0 && GRID_SHOW_DELETE) {
                html = `<button type="button" onclick="execv2.form.multipletable.deleteRow(this)" id="btnDeletewRow" class="btn btn-secondary btn-xs btn-delete-mv">${mlBtnDelete}</button>`;
                newcell.insertAdjacentHTML("afterbegin", html);
            }
        });
    }
}

execv2.form.multipletable.addRow = function (btn, processIntegrationBasedFields, shouldSetDatePicker) {
    const tbl = btn.closest("table");
    const tbody = tbl.querySelector("tbody");
    const rows = tbody.querySelectorAll("tr");
    const row = rows[rows.length - 1];
    const newrow = row.cloneNode(true);
    tbody.appendChild(newrow);

    execv2.form.clearFormFields(newrow);

    if (shouldSetDatePicker)
        execv2.form.setDatePicker(newrow);
    execv2.form.setInputMasks(newrow);

    //Contingência ENABLE_LEGACY_FORM_INTEGRATIONS: a flag é publicada pela wfFlow_Execute.v2.aspx
    //quando ativa, a nova linha é processada pelos scripts da 4.120
    if (window.enableLegacyFormIntegrations) {
        execv2.form.processSelect();
        execv2.form.processSubSelect(newrow);
        execv2.form.processSuggestionsTable(newrow);
        execv2.form.processSearchAndFill();
    }
    else {
        execv2.form.processIntegrationBasedFieldsOnNewRow(newrow, processIntegrationBasedFields);
    }

    //dispara um evento que será capturado pela automação de campos para atualizar
    //as regras para considerar os novos campos
    const event = new CustomEvent('multipletable-updatedRows', { detail: 'linha adicionada' });
    tbl.dispatchEvent(event);

    // adicionar os eventos de calculos matematicos na linha adicionada
    if (typeof formulaObj !== 'undefined' && formulaObj)
        formulaObj.addEventsToNewlyAddedRow();
}

execv2.form.multipletable.deleteRow = function (btn) {
    const tbl = btn.closest("table");
    const rows = tbl.rows;
    if (rows.length > 2) {
        const row = btn.closest("tr");
        const rowIndex = row.rowIndex;
        tbl.deleteRow(row.rowIndex);

        //dispara um evento que será capturado pela automação de campos para atualizar
        //as regras para considerar os novos campos
        const event = new CustomEvent('multipletable-updatedRows', { detail: `linha ${rowIndex} removida` });
        tbl.dispatchEvent(event);

        // chamar evento para recalcular a tabela
        if ('formulaObj' in window) formulaObj?.triggerBlurFields(row);
    } else {
        bsml.alert(mlMsgLineDeletionNotAllowed);
    }
}

execv2.form.multipletable.setup();